import { MRT_ColumnDef } from "material-react-table";
import { Box, Button, Chip, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import CustomPopup from "../../../../shared/components/modals/custom-popup";
import CBReasonDetails from "./cb-reason-deatils";
import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../../../shared/components/buttons/buttons";
import ModalPopup from "../../../../shared/components/modals/custom-popup";
import DataDisplay from "../tc-components/tc-error-detail-panel";
import moment from "moment";
import { StyledButton } from "../../../../shared/components/buttons/custom-button";
import { ActionsMenu } from "../../../../shared/components/table/custom-actions";
import { useApi } from "../../../../shared/hooks/useApi";
import { TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import { useTransactionCertificateStore } from "../../../../store/transaction-certificates.store";
import { ICbLandingPageDTrackitTableDataV4 } from "../../../../screens/v4/transaction-certificates/tc-models/tc-resp-dto/cb-landingpage.res_dto";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RateReviewIcon from '@mui/icons-material/RateReview';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import useRecordsStore from "../../../../shared/hooks/useRecordStore";
import { TcPdfUploaderModal } from "./TcPdfUploaderModal";
import FileView from "../tc-components/ml-files-detail-panel";
import { MLAppConfig } from "../../../../shared/app-configs/ml-app-configs";
import ViewerModalPopup from "../../../../shared/components/modals/viewerModal";
import PdfViewer from "../../../../shared/components/preview/pdf-viewer";
import { formatTcV4Decimal } from "../tc-v4-decimals";
// Common status cell renderer
export const StatusCell = ({ cell }: { cell: any }) => {
    const status = cell.getValue() as string;
    let color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" = "default";
    switch (status) {
        case "Submitted": color = "success"; break;
        case "Success": color = "success"; break;
        case "Amending": color = "info"; break;
        case "Rejected": color = "error"; break;
        case "Created": color = "warning"; break;
        case "Draft": color = "warning"; break;
        default: color = "default";
    }
    return <Chip label={status} color={color} size="small" variant="outlined" />;
};

export const certifiedWeightCell = ({ cell }: { cell: any }) => {
    const weightUsed = cell.getValue() as string;
    if (Number(weightUsed) > 0) {
        return formatTcV4Decimal(weightUsed);
    }
    return weightUsed
};


interface NavTCNoProps {
    cell: {
        getValue: () => string;
        row: {
            original: {
                tcMetadataStatus: string;
                tcId: string;
                tcParentMetadataStatus: string;
                tcNo?: string;
                tcVersionNo?: string;
                tcPdfUploadStatus?: string;
                tcUploadedFileName?: string;
                tcNoPdfUrl?: string;
                tcVersionNoPdfUrl?: string;
                tcUploadedFiles?: Array<{ fileName: string; blobUrl: string; uploadedDate: string }>;
                tcDateOfIssue?: string;
            };
        };
    },
    type: string;
}
const NavTCNo: React.FC<NavTCNoProps> = ({ cell, type }) => {
    const navigate = useNavigate();
    const { setEditTCInfo,cbLicensingCode } = useTransactionCertificateStore();
    // Extracting necessary values
    const tcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, tcId, tcParentMetadataStatus } = cell.row.original;
    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        if (type === 'suppliers') {
            navigate(`/v4/tc/submited-tc/transaction-certificate/${tcId}`);
            return;
        }
        else {
            if (
              tcParentMetadataStatus === "Submitted" || 
              tcParentMetadataStatus === "Success" || 
              tcParentMetadataStatus === "Rejected" ||
              tcMetadataStatus === "Amending"
            ) {
                setEditTCInfo({ tcId: tcId, isParentStatus: true });
            }
            else {
                setEditTCInfo({ tcId: tcId, isParentStatus: false });
            }
            navigate(`/v4/tc/base-details/transaction-certificate/${tcId}`);
        }
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {tcNo}
        </Typography>
    );
};


// const EditNavTCNo: React.FC<NavTCNoProps> = ({ cell, type }) => {
//     const navigate = useNavigate();
//     const row = cell.row.original;
//     // Extracting necessary values
//     const tcNo = cell.getValue(); // Transaction Certificate Number
//     const { tcId, tcMetadataStatus } = cell.row.original;

//     // Click handler to navigate based on tcMetadataStatus
//     const handleNavigation = () => {
//         console.log(`row value edit ${JSON.stringify(row)}`);

//         // if (type === 'suppliers') {
//         //     navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
//         // }
//         // else
//         //     navigate(`/tc/tc-details/transaction-certificate/${tcId}`);
//     };

//     return (
//         <>
//             {
//                 row.tcMetadataStatus === 'Submitted' || row.tcMetadataStatus === 'Success' || row.tcMetadataStatus === 'Rejected' ?
//                     <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Edit" onClick={handleNavigation}>
//                     </CustomButton> : null
//             }
//         </>
//     );
// };
interface NavETCNoProps {
    cell: {
        getValue: () => string;
        row: {
            original: {
                tcMetadataStatus: string;
                etcId: string;
            };
        };
    };
}

export const NavETCNo: React.FC<NavETCNoProps> = ({ cell }) => {
    const navigate = useNavigate();

    // Extracting necessary values
    const etcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, etcId } = cell.row.original;

    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        navigate(`/etc/view-etc/transaction-details/${etcId}`);
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {etcNo}
        </Typography>
    );
};
export const NavSupNo: React.FC<any> = ({ cell }) => {
    const navigate = useNavigate();

    // Extracting necessary values
    const tcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, tcId } = cell.row.original;

    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        navigate(`/v4/tc/submited-tc/transaction-certificate/${tcId}`);
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {tcNo}
        </Typography>
    );
};
const RejectReasonCell = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const rejectionReasons = Array.isArray(row.original.tcMetadataRejectionReason)
        ? row.original.tcMetadataRejectionReason
        : [row.original.tcMetadataRejectionReason];

    return (
        <>
            {Array.isArray(row.original.tcMetadataRejectionReason) ? (
                <>
                    <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Show Reason" onClick={handleOpen}>
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Rejection Reason">
                        <DataDisplay data={rejectionReasons} />
                    </ModalPopup>
                </>
            ) : (
                <span>{row.original.tcMetadataRejectionReason}</span>
            )}
        </>
    );
};

export const InventoryFIlesView = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);
    const [sasUrls, setSasUrls] = useState<{[key: string]: string}>({});
    const [isLoading, setIsLoading] = useState(false);

    const handleOpen = () => {
        setOpen(true);
        fetchSasUrls();
    };
    
    const handleClose = () => setOpen(false);
    
    const { executeGet } = useApi();
    const files = Array.isArray(row.original.files)
        ? row.original.files
        : [row.original.files];

    const hasFiles = row.original.files && 
                    (Array.isArray(row.original.files) 
                      ? row.original.files.length > 0
                      : (row.original.files.fileName && row.original.files.fileName.length > 0));

    const getSasUrl = async (filePath: string) => {
        try {
            const formattedPath = `['${filePath}']`;
            console.log("formattedPath", formattedPath);
            const result: any = await executeGet(MLAppConfig.GET_SAS_URL, {
                files: formattedPath
            });
            console.log("sasURL------->", JSON.stringify(result.data));
            return result.data[0];
        } catch (error: any) {
            throw new Error(`Failed to get SAS URL: ${error.message}`);
        }
    };
    
    const fetchSasUrls = async () => {
        if (!row.original.files || !row.original.files.filePath) return;
        
        setIsLoading(true);
        try {
            const urls: {[key: string]: string} = {};
            const filePaths = row.original.files.filePath;
            const fileNames = row.original.files.fileName;
            
            if (Array.isArray(filePaths)) {
                for (let i = 0; i < filePaths.length; i++) {
                    const url = await getSasUrl(filePaths[i]);
                    urls[fileNames[i]] = url;
                }
            }
            // console.log("urls-------->", urls);
            setSasUrls(urls);
        } catch (error) {
            console.error("Error fetching SAS URLs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {hasFiles ? (
                <>
                    <CustomButton 
                        variant="text" 
                        sx={{ textTransform: "none" }} 
                        size="small" 
                        label="Show Files" 
                        onClick={handleOpen}
                    >
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Inventory Files">
                        <FileView files={files} sasUrls={sasUrls} isLoading={isLoading} />
                    </ModalPopup>
                </>
            ) : (
               <span> </span>
            )}
        </>
    );
};
// Blob URLs point at storage directly, which requires VPN to reach — an
// in-app preview would just fail for anyone off-VPN. Surface the filename on
// hover only; use the eye icon (get-preview-tc-v4) for an in-app-viewable
// preview instead. Mirrors the SC landing page's UploadedFileLink pattern.
const UploadedFileLink = ({ fileName, isBase }: { fileName: string; isBase: boolean }) => (
    <Tooltip title={fileName} arrow placement="top">
        <Chip
            label={isBase ? "TC No PDF" : "TC Version No PDF"}
            variant="outlined"
            size="small"
            sx={{
                cursor: "default",
                fontWeight: 600,
                fontSize: "11px",
                borderRadius: "6px",
                borderColor: isBase ? "rgba(45, 106, 79, 0.35)" : "rgba(249, 115, 22, 0.35)",
                backgroundColor: isBase ? "rgba(45, 106, 79, 0.04)" : "rgba(249, 115, 22, 0.04)",
                color: isBase ? "#2d6a4f" : "#d97706",
            }}
        />
    </Tooltip>
);

const EditTC: React.FC<NavTCNoProps> = ({ cell, type }) => {
    const { tcId, tcMetadataStatus, tcParentMetadataStatus, tcNo, tcVersionNo, tcPdfUploadStatus, tcUploadedFileName, tcNoPdfUrl, tcVersionNoPdfUrl, tcUploadedFiles, tcDateOfIssue } = cell.row.original;
    const navigate = useNavigate();
    const { setEditTCInfo, cbLicensingCode } = useTransactionCertificateStore();
    const { executePost } = useApi();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [suppressRowClick, setSuppressRowClick] = useState(false);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const isCbUser = cbLicensingCode.startsWith("CB");
    const { fetchRecords, pagination, updateDTrackitV4Row } = useRecordsStore();

    const handleNavigation = (row: any) => {
        if (type === 'suppliers') {
            navigate(`/v4/tc/submited-tc/transaction-certificate/${tcId}`);
        } else {
            if (
                row?.tcMetadataStatus === "Submitted" ||
                row?.tcMetadataStatus === "Success" ||
                row?.tcMetadataStatus === "Rejected" ||
                row?.tcMetadataStatus === "Amending"
            ) {
                setEditTCInfo({ tcId: tcId, isParentStatus: true });
            } else {
                setEditTCInfo({ tcId: tcId, isParentStatus: false });
            }
            navigate(`/v4/tc/tc-details/base-details/${tcId}`);
        }
    };

    const handleEdit = async (row: any) => {
        try {
            const { tcVersionNumber, tcVersionNo: tcVersionNoFromRow, ...restData } = row;
            const tcVersionNo = tcVersionNoFromRow ?? tcVersionNumber ?? 0;

            const payload = {
                ...restData,
                tcVersionNo,
                tcCbLicensingCode: cbLicensingCode,
            };

            const url = `${TCAppConfig.EDIT_TC_DETAILS_V4}?tcId=${tcId}&tcCbLicensingCode=${encodeURIComponent(cbLicensingCode)}`;
            const result: any = await executePost(url, payload);

            if (result && result.status === 200) {
                if (
                    tcMetadataStatus === "Submitted" ||
                    tcMetadataStatus === "Success" ||
                    tcMetadataStatus === "Rejected"
                ) {
                    setEditTCInfo({
                        tcId: result.data.tcId,
                        isParentStatus: true,
                        tcMetadataStatus: tcMetadataStatus,
                    });
                } else {
                    setEditTCInfo({});
                }
                navigate(`/v4/tc/tc-details/base-details/${result.data.tcId}`);
            } else {
                console.warn('Edit TC did not return success:', result);
            }
        } catch (error: any) {
            console.error('Error editing TC:', error);
        }
    };

    const handleView = (event: React.MouseEvent) => {
        event.stopPropagation();
        setSuppressRowClick(false);
        setPreviewOpen(true);
    };

    const togglePreviewDrawer = (event?: React.MouseEvent) => {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        setSuppressRowClick(true);
        setPreviewOpen(false);
        setTimeout(() => setSuppressRowClick(false), 0);
    };

    const isIssueDateMissing = !tcDateOfIssue || tcDateOfIssue.toLowerCase() === 'none';

    const handleUploadPdf = (event: React.MouseEvent) => {
        event.stopPropagation();
        setUploadModalOpen(true);
    };

    const handleUploadSuccess = async (uploadResponse?: any) => {
        // TC upload API returns status + file info at the top level of the response body.
        if (uploadResponse?.tcPdfUploadStatus === 'Uploaded') {
            const updates: Partial<ICbLandingPageDTrackitTableDataV4> = {
                tcPdfUploadStatus: uploadResponse.tcPdfUploadStatus,
            };

            if (uploadResponse.tcNoPdfUrl)        updates.tcNoPdfUrl        = uploadResponse.tcNoPdfUrl;
            if (uploadResponse.tcVersionNoPdfUrl)  updates.tcVersionNoPdfUrl = uploadResponse.tcVersionNoPdfUrl;
            if (uploadResponse.tcDocumentUrl)      updates.tcDocumentUrl     = uploadResponse.tcDocumentUrl;

            const docName = uploadResponse.tcDocumentName || uploadResponse.tcUploadedFileName;
            if (docName) updates.tcUploadedFileName = docName;

            if (Array.isArray(uploadResponse.tcUploadedFiles) && uploadResponse.tcUploadedFiles.length > 0) {
                const existing = Array.isArray(tcUploadedFiles) ? tcUploadedFiles : [];
                updates.tcUploadedFiles = [...existing, ...uploadResponse.tcUploadedFiles];
            }

            updateDTrackitV4Row(tcId, updates);
            return;
        }

        // Fallback: full re-fetch when response doesn't carry the expected fields
        await fetchRecords({ tcCbLicensingCode: cbLicensingCode, source: 'dTrackitV4', pagination });
    };

    return (
        <>
            <Box
                display="flex"
                alignItems="center"
                gap={0.5}
                onClick={() => {
                    if (!previewOpen && !suppressRowClick) {
                        handleNavigation(cell.row.original);
                    }
                }}
            >
                {["Success", "Amending"].includes(tcMetadataStatus) && (
                    <>
                        <Tooltip title={isIssueDateMissing ? "Issue date missing — open to view details" : "Upload PDF"} arrow>
                            <IconButton
                                size="small"
                                onClick={handleUploadPdf}
                                sx={{
                                    color: '#2C4748',
                                    '&:hover': { backgroundColor: 'rgba(44,71,72,0.08)', color: '#2C4748' }
                                }}
                            >
                                <UploadFileIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        </Tooltip>
                    </>
                )}

                {(["Success", "Rejected"].includes(tcMetadataStatus)) && (
                    <>
                        <Tooltip title="Edit" arrow>
                            <IconButton
                                size="small"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleEdit(cell.row.original);
                                }}
                                sx={{
                                    color: '#353C52',
                                    '&:hover': { backgroundColor: 'rgba(53,60,82,0.08)', color: '#353C52' }
                                }}
                            >
                                <EditIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        </Tooltip>
                    </>
                )}

                {["Amending", "Draft"].includes(tcMetadataStatus) && isCbUser && (
                    <>
                        <Tooltip title="Continue Submission" arrow>
                            <IconButton
                                size="small"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    handleNavigation(cell.row.original);
                                }}
                                sx={{
                                    color: '#2C4748',
                                    '&:hover': { backgroundColor: 'rgba(44,71,72,0.08)', color: '#2C4748' }
                                }}
                            >
                                <RateReviewIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        </Tooltip>
                    </>
                )}

                {tcMetadataStatus !== 'Draft' && (
                    <Tooltip title="View PDF" arrow>
                        <IconButton
                            size="small"
                            onClick={handleView}
                            sx={{
                                color: '#F0CD7F',
                                '&:hover': { backgroundColor: 'rgba(240,205,127,0.15)', color: '#F0CD7F' }
                            }}
                        >
                            <VisibilityIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>

            {["Success", "Amending"].includes(tcMetadataStatus) && (
                <TcPdfUploaderModal
                    open={uploadModalOpen}
                    onClose={() => setUploadModalOpen(false)}
                    tcId={tcId}
                    tcNo={tcNo || ''}
                    tcVersionNo={tcVersionNo || ''}
                    tcNoPdfUrl={tcNoPdfUrl}
                    tcVersionNoPdfUrl={tcVersionNoPdfUrl}
                    tcUploadedFiles={tcUploadedFiles}
                    submissionStatus={tcMetadataStatus}
                    cbLicensingCode={cbLicensingCode}
                    tcDateOfIssue={tcDateOfIssue}
                    onUploadSuccess={handleUploadSuccess}
                />
            )}

            {tcId && (
                <ViewerModalPopup
                    open={previewOpen}
                    onClose={togglePreviewDrawer}
                    title="Preview"
                >
                    <div style={{ width: '100%', height: '100vh' }}>
                        <PdfViewer apiUrl={TCAppConfig.PREVIEW_TC_V4} params={{ tcId }} />
                    </div>
                </ViewerModalPopup>
            )}
        </>
    );
};

// ─── Uploaded-PDF cell: click filename → full-screen PDF preview modal ───────
const UploadedFilePdfCell = ({ cell, row }: { cell: any; row: any }) => {
    const fileName = cell.getValue() as string;
    const { tcDocumentUrl } = row.original;
    const [previewOpen, setPreviewOpen] = useState(false);

    if (!fileName) return <span>—</span>;

    const handleOpen = (event: React.MouseEvent) => {
        event.stopPropagation();
        setPreviewOpen(true);
    };

    const handleClose = (event?: React.MouseEvent) => {
        if (event) event.stopPropagation();
        setPreviewOpen(false);
    };

    return (
        <>
            <Tooltip title={tcDocumentUrl ? `Click to view: ${fileName}` : fileName} arrow>
                <Typography
                    variant="body2"
                    onClick={tcDocumentUrl ? handleOpen : undefined}
                    sx={{
                        cursor: tcDocumentUrl ? 'pointer' : 'default',
                        color: tcDocumentUrl ? 'primary.main' : '#2C4748',
                        textDecoration: tcDocumentUrl ? 'underline' : 'none',
                        fontWeight: 500,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 200,
                        '&:hover': tcDocumentUrl ? { color: 'primary.dark' } : {},
                    }}
                >
                    {fileName}
                </Typography>
            </Tooltip>

            {tcDocumentUrl && previewOpen && (
                <ViewerModalPopup
                    open={previewOpen}
                    onClose={handleClose}
                    title={`Uploaded Document — ${fileName}`}
                >
                    <iframe
                        src={tcDocumentUrl}
                        title={fileName}
                        width="100%"
                        height="100%"
                        style={{ border: 'none', minHeight: '80vh' }}
                    />
                </ViewerModalPopup>
            )}
        </>
    );
};
// ─────────────────────────────────────────────────────────────────────────────

export const tableColumns = {
    dTrackit: [
        {
            accessorKey: "Action",
            header: "",
            minSize: 40,
            maxSize: 60,
            Cell: EditTC,

        },
        {
            accessorKey: "tcNo",
            header: "TC No.",
            minSize: 70,
            maxSize: 100
        },
        {
            accessorKey: "tcVersionNumber",
            header: "TC Version No.",
            minSize: 120,
            maxSize: 150,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 100,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 100,
            maxSize: 180,
        },
        {
            accessorKey: "tcStandard",
            header: "TC Standard",
            minSize: 100,
            maxSize: 180,
        Cell: ({ cell }: { cell: any }) => {
            const standards = cell.getValue();
            if (Array.isArray(standards)) {
                return <span>{standards.join(", ")}</span>;
            }
            return <span>{standards}</span>;
        }
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 200,
            maxSize: 250,
            Cell: certifiedWeightCell
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Submission Status",
            minSize: 120,
            maxSize: 170,
            Cell: StatusCell
        },
        {
            accessorKey: "tcCreationDate",
            header: "Submitted Date",
            minSize: 100,
            maxSize: 150,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue(); // Access the raw date value
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD") // Format valid date
                    : date; // Fallback to raw value if invalid
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 140,
            Cell: ({ row }: any) => <RejectReasonCell row={row} />,
        },
        {
            accessorKey: "tcParentMetadataStatus",
            header: "Parent Reject Reason",
            minSize: 80,
            maxSize: 140,
            enableHiding: true,
            show: false,
        },
        {
          accessorKey: "tcId",
          header: "TC-ID",
          minSize: 80,
          maxSize: 140,
          enableHiding: true,
          show: false,
        }
    ] as MRT_ColumnDef<{ status: string }>[],

    dTrackitV4: [
        {
            accessorKey: "Action",
            header: "",
            size: 90,
            minSize: 90,
            maxSize: 110,
            enableColumnFilter: false,
            enableSorting: false,
            enableColumnActions: false,
            Cell: EditTC,
        },
        {
            accessorKey: "tcNo",
            header: "TC Number",
            size: 200,
            minSize: 180,
            maxSize: 260,
            Cell: ({ cell, row }: any) => {
                const tcNo = cell.getValue();
                const submittedFromUi = row.original.submittedFromUi;
                const isApi = submittedFromUi === "No" || submittedFromUi === "no" || submittedFromUi === false;
                const isUi = submittedFromUi === "Yes" || submittedFromUi === "yes" || submittedFromUi === true || submittedFromUi === "";
                const hasSource = isApi || isUi;

                return (
                    <Box display="flex" alignItems="center" gap={1}>
                        <span>{tcNo}</span>
                        {hasSource && (
                            <Chip
                                label={isApi ? "Api" : "UI"}
                                size="small"
                                sx={{
                                    height: '18px',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    borderColor: isApi ? '#ed6c02' : '#2e7d32',
                                    color: isApi ? '#ed6c02' : '#2e7d32',
                                    backgroundColor: isApi ? 'rgba(237, 108, 2, 0.05)' : 'rgba(46, 125, 50, 0.05)',
                                    border: `1px solid ${isApi ? 'rgba(237, 108, 2, 0.3)' : 'rgba(46, 125, 50, 0.3)'}`,
                                    borderRadius: '4px',
                                    cursor: 'default',
                                    '& .MuiChip-label': {
                                        paddingLeft: '4px',
                                        paddingRight: '4px',
                                    }
                                }}
                            />
                        )}
                    </Box>
                );
            }
        },
        {
            accessorKey: "tcVersionNo",
            header: "TC Version Number",
            size: 200,
            minSize: 180,
            maxSize: 260,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            size: 180,
            minSize: 120,
            maxSize: 1000,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            size: 160,
            minSize: 120,
            maxSize: 1000,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            size: 165,
            minSize: 155,
            maxSize: 1000,
        },
        {
            accessorKey: "tcStandard",
            header: "TC Standard",
            size: 135,
            minSize: 120,
            maxSize: 1000,
            Cell: ({ cell }: { cell: any }) => {
                const value = cell.getValue();
                const selectedValues = typeof value === 'string'
                    ? value.split(",").map(v => v.trim())
                    : (Array.isArray(value) ? value : []);
                if (!selectedValues || selectedValues.length === 0 || (selectedValues.length === 1 && !selectedValues[0])) {
                    return null;
                }
                return (
                    <Box display="flex" flexWrap="wrap" gap="4px">
                        {selectedValues.map((val: any) => {
                            const cleanVal = String(val).trim();
                            if (!cleanVal) return null;
                            return (
                                <Tooltip title={cleanVal} arrow key={cleanVal}>
                                    <Chip
                                        label={cleanVal}
                                        size="small"
                                        sx={{
                                            backgroundColor: 'rgba(44, 71, 72, 0.08)',
                                            color: '#2C4748',
                                            fontWeight: 'bold',
                                            border: '1px solid rgba(44, 71, 72, 0.2)',
                                            borderRadius: '6px',
                                            fontSize: '11px',
                                            height: '22px',
                                            textTransform: 'uppercase',
                                            cursor: 'help',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                backgroundColor: '#2C4748',
                                                color: '#FFFFFF',
                                            }
                                        }}
                                    />
                                </Tooltip>
                            );
                        })}
                    </Box>
                );
            },
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            size: 200,
            minSize: 190,
            maxSize: 1000,
            Cell: certifiedWeightCell,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            size: 120,
            minSize: 110,
            maxSize: 1000,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Submission Status",
            size: 160,
            minSize: 150,
            maxSize: 1000,
            Cell: StatusCell,
        },

        {
            accessorKey: "tcCreationDate",
            header: "Submitted Date",
            minSize: 100,
            maxSize: 150,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue();
                // Handle 'None' or empty string values
                if (!date || date === '') {
                    return '-';
                }
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD")
                    : '-';
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 140,
            Cell: ({ row }: any) => <RejectReasonCell row={row} />,
        },
        {
            accessorKey: "tcId",
            header: "TC-ID",
            minSize: 80,
            maxSize: 140,
            enableHiding: true,
            show: false,
        },
        {
            accessorKey: "tcUploadedFiles",
            header: "Uploaded File(s)",
            minSize: 160,
            maxSize: 260,
            enableHiding: true,
            enableColumnFilter: false,
            Cell: ({ cell, row }: { cell: any; row: any }) => {
                const rawFiles: Array<{ fileName: string; uploadedAt?: string }> = cell.getValue() || [];
                if (!rawFiles || rawFiles.length === 0) return null;

                const normalize = (str: string) => (str || "").toLowerCase().replace(/[-_\s]/g, "");
                // SC-style filter: show only the base certificate (-00) and the current active version.
                // Intermediate amendments are kept in the DB but hidden — same as SC behaviour.
                const normTcNo        = normalize(row.original.tcNo || '');        // always the -00 base
                const normTcVersionNo = normalize(row.original.tcVersionNo || ''); // current active version

                // Sort most-recent first, then filter to base + current only
                const sorted = [...rawFiles].sort((a, b) => {
                    const ta = a.uploadedAt ? new Date(a.uploadedAt).getTime() : 0;
                    const tb = b.uploadedAt ? new Date(b.uploadedAt).getTime() : 0;
                    return tb - ta;
                });

                const filtered = sorted.filter((entry: any) => {
                    const normName = normalize(entry.fileName || entry || "");
                    const matchesBase    = normTcNo && normName.includes(normTcNo);
                    const matchesCurrent = normTcVersionNo && normTcVersionNo !== normTcNo
                                          && normName.includes(normTcVersionNo);
                    return matchesBase || matchesCurrent;
                });

                if (filtered.length === 0) return null;

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                        {filtered.map((entry: any, idx: number) => {
                            const fn = entry.fileName || '';
                            const normName = normalize(fn);
                            const matchesCurrent = normTcVersionNo && normTcVersionNo !== normTcNo
                                                  && normName.includes(normTcVersionNo);
                            const isBase = !matchesCurrent;
                            return <UploadedFileLink key={idx} fileName={fn} isBase={isBase} />;
                        })}
                    </div>
                );
            },
        },
        {
            accessorKey: "tcPdfUploadStatus",
            header: "Upload Status",
            minSize: 110,
            maxSize: 160,
            enableHiding: true,
            Cell: ({ cell, row }: { cell: any; row: any }) => {
                const status = cell.getValue() as string;
                const metadataStatus = row.original.tcMetadataStatus;

                if (!status) {
                    return ["Success", "Amending"].includes(metadataStatus) ? (
                        <Chip label="Not Uploaded" color="default" size="small" variant="outlined" />
                    ) : null;
                }

                const color: "success" | "default" = status === "Uploaded" ? "success" : "default";
                return <Chip label={status} color={color} size="small" variant="outlined" />;
            },
        },
    ] as MRT_ColumnDef<{ status: string }>[],

    historical: [
        {
            accessorKey: "tcId",
            header: "TC No.",
            minSize: 60,
            maxSize: 150
        },
        {
            accessorKey: "tcVersionNumber",
            header: "TC Version No.",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 80,
            maxSize: 140,
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 100,
            maxSize: 150,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,

        }
    ] as MRT_ColumnDef<{ status: string }>[],

    eTrackit: [
        {
            accessorKey: "etcNo",
            header: "eTC No.",
            minSize: 60,
            maxSize: 100,
            Cell: NavETCNo
        },
        {
            accessorKey: "etcVersionNumber",
            header: "eTC Version No.",
            minSize: 100,
            maxSize: 160,
        },
        {
            accessorKey: "etcStatus",
            header: "eTC Status",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer's Country/Area",
            minSize: 200,
            maxSize: 250,
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "eTC Certified Weight (kg)",
            minSize: 300,
            maxSize: 350,
        },
        {
            accessorKey: "tcCreationDate",
            header: "Creation Date",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issued Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "pendingDays",
            header: "Pending Days",
            minSize: 100,
            maxSize: 140,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Current Status",
            minSize: 80,
            maxSize: 150,
            Cell: StatusCell
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 150,
        }
    ] as MRT_ColumnDef<{ status: string }>[],
    suppliers: [
        {
            accessorKey: 'tcNo', // From payload
            header: 'TC/e TC ID', // Column header text
            minSize: 150,
            maxSize: 250,
            Cell: NavSupNo
        },
        {
            accessorKey: 'buyerName', // Combined Buyer/Seller
            header: 'Buyer',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'sellerName', // Combined Buyer/Seller
            header: 'Seller',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tcCreationDate', // From payload
            header: 'Creation Date',
            minSize: 150,
            maxSize: 250,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue(); // Access the raw date value
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD") // Format valid date
                    : date; // Fallback to raw value if invalid
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: 'tcDateOfIssue', // From payload
            header: 'Issue Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'volumeSold', // Placeholder as it's not in the payload
            header: 'Volume Sold',
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: 'volumeBought', // Placeholder as it's not in the payload
            header: 'Volume Bought',
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: 'tcStatus', // From payload
            header: 'Status',
            minSize: 150,
            maxSize: 200,
            Cell: ({ cell }: any) => {
                const statusMapping: Record<string, string> = {
                    V: "Valid",
                    E: "Expired",
                    S: "Suspended",
                    W: "Withdrawn",
                };

                // Extract the status value from the row data
                const statusValue = cell.getValue();

                // Map the status value to the corresponding label
                const label = statusMapping[statusValue] || statusValue;

                return <span>{label}</span>;
            }
        },
    ] as MRT_ColumnDef<{ status: string }>[],
    materialLedger: [
        {
            accessorKey: 'transactionType',
            header: 'Transaction Type',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'inventoryType',
            header: 'Inventory Type',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tCeTCMDFNumber',
            header: 'Transaction/MDF No.',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'sellerBuyerName',
            header: 'Seller/Buyer Name',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'transactionDate',
            header: 'Transaction Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productNumber',
            header: 'Product No.',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productCategory',
            header: 'Product Category',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productDetail',
            header: 'Product Detail',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'rmComposition',
            header: 'RM Composition',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedRmCode',
            header: 'Certified RM CD',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedWeightBought',
            header: 'Certified Weight Purchased (kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedWeightSold',
            header: 'Certified Weight Sold (kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'inputTcCertificateUsed',
            header: 'Certified Volume Used',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'balance',
            header: 'Balance',
            minSize: 150,
            maxSize: 250,
        },
    ] as MRT_ColumnDef<{ status: string }>[],
};

export const getColumnsBySource = (source: string) => {
    switch (source) {
        case "dTrackit":
            return tableColumns.dTrackit;
        case "dTrackitV4":
            return tableColumns.dTrackitV4;
        case "historical":
            return tableColumns.historical;
        case "eTrackit":
            return tableColumns.eTrackit;
        case "suppliers":
            return tableColumns.suppliers;
        case "materialLedger":
            return tableColumns.materialLedger;
        default:
            return tableColumns.dTrackit; // fallback
    }
};
